import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { PurchaseInvoice } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PurchaseInvoiceService extends BaseService<PurchaseInvoice> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/purchase_invoice'
  }

  public sendToExact = (id: number): Observable<Response<PurchaseInvoice>> => {
    return this._http.post<Response<PurchaseInvoice>>(`${this.getUrl(this.path)}/${id}/export/exact`, {});
  }

  public downloadPdf = (invoiceId: number): Observable<Blob> => {
    return this._http.get(
      `${this.getUrl(this.path)}/${invoiceId}/pdf`,
      {
        responseType: 'blob'
      }
    );
  }

  public sendEmail = (invoiceId: number): Observable<Response<PurchaseInvoice>> => {
    return this._http.post<Response<PurchaseInvoice>>(`${this.getUrl(this.path)}/${invoiceId}/send_email`, {});
  }

  public mergeInvoices = (invoiceIds: {id: number}[]): Observable<Response<PurchaseInvoice>> => {
    return this._http.post<Response<PurchaseInvoice>>(`${this.getUrl('api/purchase_invoices/merge')}`, invoiceIds);
  }
}
